import React from 'react';
import { band } from '../data/band';
import '../styles/components/Footer.css';

const Footer: React.FC = () => {
  const currentYear: number = new Date().getFullYear();

  return (
    <div className="footer-content">
      <div className="social-links">
        {band.facebook && (
          <a href={band.facebook} target="_blank" rel="noopener noreferrer" aria-label="Facebook">
            <i className="fab fa-facebook"></i>
          </a>
        )}
        {band.instagram && (
          <a href={band.instagram} target="_blank" rel="noopener noreferrer" aria-label="Instagram">
            <i className="fab fa-instagram"></i>
          </a>
        )}
        {band.youtube && (
          <a href={band.youtube} target="_blank" rel="noopener noreferrer" aria-label="YouTube">
            <i className="fab fa-youtube"></i>
          </a>
        )}
        {band.twitch && (
          <a href={band.twitch} target="_blank" rel="noopener noreferrer" aria-label="Twitch">
            <i className="fab fa-twitch"></i>
          </a>
        )}
      </div>
      <p>&copy; {currentYear} Lost Signal. All rights reserved.</p>
      <p>Albert Lea, Minnesota</p>
    </div>
  );
};

export default Footer;
